export function AuthBrandPanel() {
  return (
    <aside className="auth-brand-panel" aria-label="Emazy account benefits">
      <div className="auth-brand-panel__art" aria-hidden="true">
        <span className="auth-brand-panel__wood">
          <i className="pi pi-heart" />
        </span>
        <span className="auth-brand-panel__ornament">
          <i className="pi pi-star" />
        </span>
      </div>
      <p className="eyebrow">Your ideas, ready when you are</p>
      <h2>
        Create meaningful gifts.
        <br />
        Save your designs.
        <br />
        Reorder with ease.
      </h2>
      <p>
        Accounts are the future home for personalized projects, order progress, and repeat
        favorites.
      </p>
    </aside>
  );
}
